/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 * 
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Injectable, InjectionToken, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/toPromise';

export class ConfigServiceSetup {
    url: string;
}

@Injectable()
export class ConfigService {

    private appConfig: any = {};

    constructor(private http: HttpClient, @Optional() private serviceConfig: ConfigServiceSetup) {}

    loadConfig() {
        return this.http.get(this.serviceConfig.url).toPromise().then(
            (response) => {
                this.appConfig = response;
                return this.config;
            },
            (error) => {
                this.appConfig = {};
                return this.config;
            }
        );
    }

    get config() {
        return this.appConfig;
    }
}

export function ConfigServiceFactory(configService: ConfigService) {
    return (() => {
        return configService.loadConfig();
    });
}

export let APP_CONFIG = new InjectionToken<any>('app.config');



// WEBPACK FOOTER //
// ./src/config/config.service.ts